/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExecRiskForm990SchAType3FuncInt
 */
export interface ExecRiskForm990SchAType3FuncInt {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990SchAType3FuncInt
     */
    ActivitiesTestInd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990SchAType3FuncInt
     */
    ParentSupportedOrgInd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990SchAType3FuncInt
     */
    GovernmentalEntityInd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990SchAType3FuncInt
     */
    ActivitiesFurtherExemptPrpsInd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990SchAType3FuncInt
     */
    ActivitiesEngagedOrgInvlmntInd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990SchAType3FuncInt
     */
    AppointElectMajorityOfficerInd?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskForm990SchAType3FuncInt
     */
    ExerciseDirectionPoliciesInd?: string;
}

/**
 * Check if a given object implements the ExecRiskForm990SchAType3FuncInt interface.
 */
export function instanceOfExecRiskForm990SchAType3FuncInt(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecRiskForm990SchAType3FuncIntFromJSON(json: any): ExecRiskForm990SchAType3FuncInt {
    return ExecRiskForm990SchAType3FuncIntFromJSONTyped(json, false);
}

export function ExecRiskForm990SchAType3FuncIntFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskForm990SchAType3FuncInt {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ActivitiesTestInd': !exists(json, 'ActivitiesTestInd') ? undefined : json['ActivitiesTestInd'],
        'ParentSupportedOrgInd': !exists(json, 'ParentSupportedOrgInd') ? undefined : json['ParentSupportedOrgInd'],
        'GovernmentalEntityInd': !exists(json, 'GovernmentalEntityInd') ? undefined : json['GovernmentalEntityInd'],
        'ActivitiesFurtherExemptPrpsInd': !exists(json, 'ActivitiesFurtherExemptPrpsInd') ? undefined : json['ActivitiesFurtherExemptPrpsInd'],
        'ActivitiesEngagedOrgInvlmntInd': !exists(json, 'ActivitiesEngagedOrgInvlmntInd') ? undefined : json['ActivitiesEngagedOrgInvlmntInd'],
        'AppointElectMajorityOfficerInd': !exists(json, 'AppointElectMajorityOfficerInd') ? undefined : json['AppointElectMajorityOfficerInd'],
        'ExerciseDirectionPoliciesInd': !exists(json, 'ExerciseDirectionPoliciesInd') ? undefined : json['ExerciseDirectionPoliciesInd'],
    };
}

export function ExecRiskForm990SchAType3FuncIntToJSON(value?: ExecRiskForm990SchAType3FuncInt | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ActivitiesTestInd': value.ActivitiesTestInd,
        'ParentSupportedOrgInd': value.ParentSupportedOrgInd,
        'GovernmentalEntityInd': value.GovernmentalEntityInd,
        'ActivitiesFurtherExemptPrpsInd': value.ActivitiesFurtherExemptPrpsInd,
        'ActivitiesEngagedOrgInvlmntInd': value.ActivitiesEngagedOrgInvlmntInd,
        'AppointElectMajorityOfficerInd': value.AppointElectMajorityOfficerInd,
        'ExerciseDirectionPoliciesInd': value.ExerciseDirectionPoliciesInd,
    };
}

